import api from './api';
import { normalizeWarehouseIds } from '../utils/receptionConsumeAutomation';

/** APIs antiguas sin clave: mantener Restaurantes visible por defecto */
function normalizeRestaurantesEnabled(value) {
  return value === undefined || value === null ? true : Boolean(value);
}

const defaultSettings = {
  machinery_enabled: true,
  produccion_enabled: false,
  produccion_concesionaria_enabled: false,
  produccion_fabricar_pep_desde_pt_enabled: false,
  produccion_lineas_enabled: false,
  restaurantes_enabled: true,
  activos_enabled: false,
  ventas_enabled: false,
  ventas_pos_product_assignment_enabled: true,
  ventas_price_ranges_enabled: false,
  ventas_offers_enabled: true,
  ventas_cash_liquidation_enabled: false,
  product_warehouse_visibility_enabled: false,
  guides_remove_stock_restrictions: false,
  exit_reference_last_purchase_cost_enabled: false,
  product_conversions_enabled: false,
  quick_product_line_enabled: true,
  reception_consume_button_enabled: false,
  reception_consume_warehouse_ids: [],
  reception_consume_single_project_enabled: false,
  products_project_enabled: false,
  products_igv_enabled: false,
  services_classification_enabled: false,
  kardex_inconsistencies_count_from_enabled: false,
  kardex_inconsistencies_count_from_date: null,
  kardex_inconsistencies_count_from_time: null,
  kardex_audit_module_enabled: false,
  kardex_temporary_cost_enabled: true,
  compras_purchase_sites_enabled: false,
};

function normalizeSettings(data) {
  return {
    machinery_enabled: Boolean(data.machinery_enabled),
    produccion_enabled: Boolean(data.produccion_enabled),
    produccion_concesionaria_enabled: Boolean(data.produccion_concesionaria_enabled),
    produccion_fabricar_pep_desde_pt_enabled: Boolean(data.produccion_fabricar_pep_desde_pt_enabled),
    produccion_lineas_enabled: data.produccion_lineas_enabled === undefined
      ? defaultSettings.produccion_lineas_enabled
      : Boolean(data.produccion_lineas_enabled),
    restaurantes_enabled: normalizeRestaurantesEnabled(data.restaurantes_enabled),
    activos_enabled: Boolean(data.activos_enabled),
    ventas_enabled: Boolean(data.ventas_enabled),
    ventas_pos_product_assignment_enabled: data.ventas_pos_product_assignment_enabled === undefined
      ? defaultSettings.ventas_pos_product_assignment_enabled
      : Boolean(data.ventas_pos_product_assignment_enabled),
    ventas_price_ranges_enabled: data.ventas_price_ranges_enabled === undefined
      ? defaultSettings.ventas_price_ranges_enabled
      : Boolean(data.ventas_price_ranges_enabled),
    ventas_offers_enabled: data.ventas_offers_enabled === undefined
      ? defaultSettings.ventas_offers_enabled
      : Boolean(data.ventas_offers_enabled),
    ventas_cash_liquidation_enabled: data.ventas_cash_liquidation_enabled === undefined
      ? defaultSettings.ventas_cash_liquidation_enabled
      : Boolean(data.ventas_cash_liquidation_enabled),
    product_warehouse_visibility_enabled: Boolean(data.product_warehouse_visibility_enabled),
    guides_remove_stock_restrictions: Boolean(data.guides_remove_stock_restrictions),
    exit_reference_last_purchase_cost_enabled: data.exit_reference_last_purchase_cost_enabled === undefined
      ? defaultSettings.exit_reference_last_purchase_cost_enabled
      : Boolean(data.exit_reference_last_purchase_cost_enabled),
    product_conversions_enabled: Boolean(data.product_conversions_enabled),
    quick_product_line_enabled: data.quick_product_line_enabled === undefined
      ? defaultSettings.quick_product_line_enabled
      : Boolean(data.quick_product_line_enabled),
    reception_consume_button_enabled: data.reception_consume_button_enabled === undefined
      ? defaultSettings.reception_consume_button_enabled
      : Boolean(data.reception_consume_button_enabled),
    reception_consume_warehouse_ids: normalizeWarehouseIds(
      data.reception_consume_warehouse_ids ?? defaultSettings.reception_consume_warehouse_ids,
    ),
    reception_consume_single_project_enabled: data.reception_consume_single_project_enabled === undefined
      ? defaultSettings.reception_consume_single_project_enabled
      : Boolean(data.reception_consume_single_project_enabled),
    products_project_enabled: data.products_project_enabled === undefined
      ? defaultSettings.products_project_enabled
      : Boolean(data.products_project_enabled),
    products_igv_enabled: data.products_igv_enabled === undefined
      ? defaultSettings.products_igv_enabled
      : Boolean(data.products_igv_enabled),
    services_classification_enabled: data.services_classification_enabled === undefined
      ? defaultSettings.services_classification_enabled
      : Boolean(data.services_classification_enabled),
    kardex_inconsistencies_count_from_enabled: data.kardex_inconsistencies_count_from_enabled === undefined
      ? defaultSettings.kardex_inconsistencies_count_from_enabled
      : Boolean(data.kardex_inconsistencies_count_from_enabled),
    kardex_inconsistencies_count_from_date: data.kardex_inconsistencies_count_from_date || null,
    kardex_inconsistencies_count_from_time: data.kardex_inconsistencies_count_from_time || null,
    kardex_audit_module_enabled: data.kardex_audit_module_enabled === undefined
      ? defaultSettings.kardex_audit_module_enabled
      : Boolean(data.kardex_audit_module_enabled),
    kardex_temporary_cost_enabled: data.kardex_temporary_cost_enabled === undefined
      ? defaultSettings.kardex_temporary_cost_enabled
      : Boolean(data.kardex_temporary_cost_enabled),
    compras_purchase_sites_enabled: data.compras_purchase_sites_enabled === undefined
      ? defaultSettings.compras_purchase_sites_enabled
      : Boolean(data.compras_purchase_sites_enabled),
  };
}

/**
 * Obtiene la configuración de módulos habilitados (para usar al iniciar el sistema).
 */
export async function getModuleSettings() {
  const response = await api.get('/module-settings');
  const data = response.data;
  if (!data.success || !data.data) {
    return { success: false, data: { ...defaultSettings } };
  }
  return {
    success: true,
    data: normalizeSettings(data.data),
  };
}

/**
 * Actualiza la habilitación de módulos en el backend.
 */
export async function updateModuleSettings(payload) {
  const response = await api.put('/module-settings', payload);
  const data = response.data;
  if (!data.success || !data.data) {
    return { success: false, data: { ...defaultSettings } };
  }
  return {
    success: true,
    data: normalizeSettings(data.data),
  };
}

export default { getModuleSettings, updateModuleSettings };
